<template>
  <v-layout row justify-center>
      <v-card>
        <v-card-title>
          <v-toolbar color="#9D4593" dark>
            <v-icon>far fa-user</v-icon>
            <v-toolbar-title>Crea tu Cuenta</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="registerForm">
            <v-container grid-list-md py-0>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-alert
                    :value="alert.state"
                    :type="alert.tipo"
                    :icon="alert.icon"
                    transition="scale-transition"
                    class="py-1"
                  >
                    {{alert.texto}}
                  </v-alert>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.nombre" label="Nombre" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.apellido" label="Apellido" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.telefono" label="Teléfono" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.email" label="Email" required :rules="rules.emailRules"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="data.password"
                    :append-icon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
                    :rules="rules.required"
                    :type="show ? 'text' : 'password'"
                    min-length="8"
                    label="Contraseña (mínimo 8 caracteres)"
                    @click:append="show = !show"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#9D4593" flat @click="dialog = false">Cancelar</v-btn>
          <!-- <v-btn style="background-color: #9D4593; color: white;" @click="createUser">Crear Cuenta</v-btn> -->
          <v-btn style="background-color: #9D4593; color: white;" @click="createUserDemo()">Crear Cuenta</v-btn>
        </v-card-actions>
      </v-card>
  </v-layout>
</template>

<script>
  import * as firebase from 'firebase/app'
  import 'firebase/auth'
  import { EventBus } from '../../events.js'
  export default{
    name: 'FormRegister',
    data () {
      return {
        dialog: false,
        show: false,
        data: {
          nombre: '',
          telefono: '',
          email: '',
          password: '',
          clase: 'demo',
          apellido: ''
        },
        alert: {
          state: false,
          texto: '',
          icon: 'fas fa-info-circle',
          tipo: 'info'
        },
        rules: {
          required: [value => !!value || 'Campo obligatorio'],
          min: [v => v.length >= 8 || 'Mínimo 8 caracteres'],
          emailRules: [
            v => !!v || 'Campo obligatorio',
            v => /.+@.+/.test(v) || 'Verifica que el email sea válido'
          ]
        },
        userNumber: 0
      }
    },
    methods:{
      createUser(){
        if(this.$refs.registerForm.validate()){
          const db = firebase.firestore()
          const here = this
          firebase.auth().createUserWithEmailAndPassword(this.data.email, this.data.password)
            .then(async function(data){
              here.data.created = firebase.firestore.FieldValue.serverTimestamp()
              here.$auth.saveUserInfo(data.user.uid, here.data)
              /* here.$auth.login(here.data.email, here.data.password) */
              here.data.password = ''
              db.collection('users').doc(data.user.uid).set(here.data)
              here.alert.state = true
              here.alert.texto = 'Tu cuenta ha sido creada.'
              here.alert.tipo = 'success'
              here.alert.icon = 'fas fa-check-circle'
              setTimeout(function() {
                here.dialog = false
              }, 2000);
              here.$store.state.idCliente = data.user.uid
              EventBus.$emit('registeredUserDemo')
            })
            .catch(function(error) {
              here.alert.state = true
              here.alert.texto = error.message
              here.alert.tipo = 'error'
              here.alert.icon = 'fas fa-exclamation-triangle'
            });
        } else {
          console.log('faltan datos')
        }
      },
      async checkUserDemo() {
        const here = this
        const db = firebase.firestore()
        await db.collection('users').where('idDemo', '==', this.data.idDemo).get().then(function(querySnapshot) {
          if (!querySnapshot.empty) {
            here.userNumber++
            here.createUserDemo()
          } else {
            here.createUser()
          }
        })
      },
      createUserDemo() {
        console.log('entra al createUserDemo')
        if(this.$refs.registerForm.validate() && this.data.password.length >= 8) {
          this.data.idDemo = this.eliminarDiacriticosEs(this.data.nombre + this.data.apellido)
          if (this.userNumber > 0) {
            const dataNumber = this.userNumber.toString()
            this.data.idDemo = this.data.idDemo + dataNumber
            this.checkUserDemo()
          } else {
            this.checkUserDemo()
          }
        } else {
          if (this.data.password.length < 8) {
              this.alert.state = true
              this.alert.texto = 'La contraseña debe tener mas de 8 caracteres'
              this.alert.tipo = 'error'
              this.alert.icon = 'fas fa-exclamation-triangle'
          }
        }
      },
      eliminarDiacriticosEs(cadena) {
        /* texto.normalize('NFD').replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize() */
        // Definimos los caracteres que queremos eliminar
        var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";
        // Los eliminamos todos
        for (var i = 0; i < specialChars.length; i++) {
            cadena= cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
        }   
        // Lo queremos devolver limpio en minusculas
        cadena = cadena.toLowerCase();
        // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
        cadena = cadena.replace(/ /g,"_");
        // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
        cadena = cadena.replace(/á/gi,"a");
        cadena = cadena.replace(/é/gi,"e");
        cadena = cadena.replace(/í/gi,"i");
        cadena = cadena.replace(/ó/gi,"o");
        cadena = cadena.replace(/ú/gi,"u");
        cadena = cadena.replace(/ñ/gi,"n");
        return cadena.toLowerCase();
      }

    }
  }
</script>